import { Col, Row } from 'reactstrap';
import CenterCenterVerticalContainer from "../../components/layout/CenterCenterVerticalContainer";
import TitleContainerComponent from '../../components/layout/TitleContainerComponent';
import MainPageComponent from "../../components/page/MainPageComponent";


function UserBudgetView() {
    let breadcrumbPath = [
        { value: 'Inicio', href: '/' },
        { value: 'Usuario', href: '/user' },
        { value: 'Presupuesto', href: '' }
    ];

	return (
		<div>
			<MainPageComponent requireAuthentication={true} path={breadcrumbPath}>
                <CenterCenterVerticalContainer>
                    <Row>
                        <Col className="col-md-6 col-12">
                            <TitleContainerComponent>
							    <h1>Este es tu presupuesto</h1>
						    </TitleContainerComponent>
                        </Col>
                        <Col className="col-md-6 col-12">
                            <Row>
                                Este es un resumen
                            </Row>
                            <Row>
                                Esta es un grafico
                            </Row>
                            <Row>
                                Esta es una tabla
                            </Row>
                        </Col>
                    </Row>
                </CenterCenterVerticalContainer>
			</MainPageComponent>
		</div>
	);
}

export default UserBudgetView;